<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">系统</a></el-breadcrumb-item>
          <el-breadcrumb-item>用户列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true" size="medium">    
          <el-row>
            <el-col :span="2"><el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="AddUser" size="small" >新增</el-button></el-col>
            <el-col :span="4"> <el-input  placeholder="用户名称" v-model="queryParam.name" size="small" clearable></el-input></el-col>
            <el-col :span="4" style="margin-left:5px"><el-input  placeholder="店铺名称" v-model="queryParam.storeName" size="small" clearable></el-input></el-col>
            <el-col :span="4" style="margin-left:5px"><el-input  placeholder="权限名称" v-model="queryParam.roleName" size="small" clearable></el-input></el-col>
            <el-col :span="2" style="margin-left:5px">
              <el-select v-model="queryParam.isLock" size="small" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>            
            <el-col :span="2"><el-button type="primary" v-on:click="Search" size="small" >查询</el-button></el-col>
          </el-row>
        </el-form>
        <el-table :data="users" style="width: 100%">
          <el-table-column  fixed  prop="Account"  label="账号" width="150"> </el-table-column>
          <el-table-column  prop="Name"  label="姓名" > </el-table-column>
          <el-table-column  prop="Mobile"  label="联系电话" > </el-table-column>
          <el-table-column  prop="RoleName"  label="权限"> </el-table-column>
          <el-table-column  prop="StoreName"  :show-overflow-tooltip="true"  label="店铺"> </el-table-column>
          <el-table-column  prop="IsLock" width="80px" label="状态"> 
            <template slot-scope="scope">
              <p v-if="scope.row.IsLock">锁定</p>
              <p v-if="scope.row.IsLock==false">正常</p>  
            </template>
          </el-table-column>
          <el-table-column  prop="RegisterTime"  label="注册时间" :formatter="dateFormat"> </el-table-column>
          <el-table-column  fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click.native.prevent="EditUser(scope.row.Id)" type="text" size="small">编辑</el-button>
            <el-button @click="DeleteRow(scope.row)" type="text" size="small">&nbsp;删除</el-button>
            <el-button @click="ChangeSate(scope.row)" type="text" size="small">&nbsp;{{scope.row.IsLock?"启用":"停用"}}</el-button>

          </template>
        </el-table-column>
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>   
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {
        users:[],
        queryParam:{
          name:'',
          storeName:'',
          isLock:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:'id desc',
        },
        options: [{
          value: '',
          label: '请选择'
        }, {
          value: '0',
          label: '正常'
        }, {
          value: '1',
          label: '锁定'
        }]
      }
    },
    computed:{
    },
    mounted(){
      if (this.$route.params.queryParam) {
        this.queryParam = this.$route.params.queryParam
      }
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      AddUser:function(){
        this.$router.push({
          name:'userInfo',
          params:{
            Id:''
          }
        })
      },
      EditUser:function(id){ 
        this.$router.push({
          name:'userInfo',
          params:{
            Id: id,
            queryParam: this.queryParam
          }
        })
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/User/index',
          params: this.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.users = resp.data.users
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },
      DeleteRow(row) {
        if(row.IsSystem){
          this.$message.warning('系统用户不允许删除!');
          return;
        }
        this.$confirm('确实要删除用户['+row.Name+']吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/User/Delete',
            data:{
              id: row.Id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
        
      },
      ChangeSate(row){
        if(row.IsSystem){
          this.$message.warning('系统用户不允许操作!');
          return;
        }
        if(row.IsLock)
          var message= '确定要启用用户['+row.Name+']吗？'
        else 
          var message= '确定要停用用户['+row.Name+']吗？'
        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/User/ChangeSate',
            data:{
              id: row.Id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      },
      handleSizeChange(val) {
        this.pagesize = val
        this.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.GetData()
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>